import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../ButtonAction';
import ModalContainer from '../ModalContainer';
import DocxEditor from '../DocxEditor';
import styles from '../PopupEditDocSyncFusion/styles.module.scss';
import ModalHeader from "../ModalHeader";

interface PopupViewDocxProps {
  fileName?: string;
  onClick: () => Promise<string>;
}

const PopupViewDocx = ({
                                                 fileName = '',
                                                 onClick,
                                               }: PopupViewDocxProps) => {
  const intl = useIntl();
  const [file, setFile] = useState<string>('');
  const [show, setShow] = useState<boolean>(false);
  const handleCloseModal = (): void => setShow(false);
  const handleShowModal = (): void => setShow(true);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await onClick();
        setFile(result);
      } catch (e) {
        console.error(e);
      }
    };

    const timer = setTimeout(load, 2000);
    return () => clearTimeout(timer);
  }, [onClick]);

  return (
    <>
      {fileName && (
        <ButtonAction
          variant="icon"
          iconButtonType="success"
          label={
            <img
              src="/media/common/Doc_green.svg"
              alt="file"
            />
          }
          onClick={handleShowModal}
        />
      )}
      <ModalContainer show={show} onHide={handleCloseModal} size="xxl">
        <>
          <ModalHeader
          type={'complex'}
          icon={'/media/common/Edit_primary.svg'}
          header={fileName}
        />
          <div className="w-100 h-100 d-flex flex-column align-items-center">
            <div className="flex-grow-1 w-100">
              <DocxEditor
                file={file}
                restrictEditing={true}
                height="72vh"
                className={styles.editor}
              />
            </div>
            <ButtonAction
              variant="cancel"
              onClick={handleCloseModal}
              label={intl.formatMessage({id: 'button-close', defaultMessage: 'Close'})}
              customClassnames="mx-auto my-4 d-block w-125px"
            />
          </div>
        </>
      </ModalContainer>
    </>
  );
};

export default PopupViewDocx;